<template>
  <div class="stihl-input-group" :class="containerClasses">

    <label :for="labelFor" :class="labelClass">
      {{ label }}
      <span v-if="required" :title="$t('adm.label.required')">*</span>
    </label>

    <slot />

    <div class="form-text" v-if="infoText">{{ infoText }}</div>

    <div class="validation-feedback" v-if="!isDisabled && validation">
      <div class="validation-error" v-for="(error, i) in validation.$errors" :key="i">
        <img src="@/assets/img/icons/circle-cross-colored.svg" alt="error">
        <span>{{ error.$message }}</span>
      </div>

      <div class="is-valid" v-if="validation.$dirty && !validation.$invalid">
        <img src="@/assets/img/icons/circle-check-colored.svg" alt="ok">
        <span>{{ $t('adm.label.valid') }}</span>
      </div>
    </div>


  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { BaseValidation } from '@vuelidate/core';

export default defineComponent({
  name: 'FormItemGroup',
  props: {
    containerClass: { type: String, default: null },
    label: { type: String, required: true },
    labelClass: { type: String, default: 'form-label' },
    labelFor: { type: String, default: null },
    required:  { type: Boolean, default: false },
    validation: { type: Object as PropType<BaseValidation>, default: undefined },
    isDisabled: { type: Boolean, default: false },
    infoText: {type: String, default: null}
  },
  computed: {
    containerClasses() {
      const c = this.isDisabled || !this.validation ? {} : {
        dirty: this.validation.$dirty,
        'has-error': this.validation.$error,
      } as Record<string, boolean>;
      if (this.containerClass) c[this.containerClass as string] = true;
      return c;
    },
  },
});
</script>

<style>
.stihl-input-group {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.stihl-input-group.has-error .form-control,
.stihl-input-group.has-error .multiselect {
  border: 1px solid var(--red-base, #D43B3B);
}

.stihl-input-group.dirty:not(.has-error) .form-control,
.stihl-input-group.dirty:not(.has-error) .multiselect {
  border: 1px solid var(--green-base, #D43B3B);
}

.stihl-input-group div, .stihl-input-group label {
  margin: 0;
}

.validation-feedback > div {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.validation-feedback div.validation-error span {
  color: var(--grey-deep, #252525);
  font-feature-settings: 'clig' off, 'liga' off;

  font-family: var(--stihl-font-family-text);
  font-size: 14px;
  line-height: 1rem;
}

.validation-feedback div.is-valid span {
  color: var(--green-deep);
  font-feature-settings: 'clig' off, 'liga' off;

  font-family: var(--stihl-font-family-text);
  font-size: 14px;
  line-height: 1rem;
}
</style>
